var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{attrs:{"outlined":""}},[_c('TransientDash',{key:_vm.coupon.uuid,attrs:{"title":_vm.$t('redemptions'),"namespace":"coupon_sales_list","config":_vm.couponValueConfig}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }